import { Component, Input, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { NA_VALUE } from 'src/app/constants';
import { IBaseTable } from 'src/app/interfaces/calibration-set-table.interface';
import { IFieldSettings } from 'src/app/interfaces/field-settings.interface';
import { IBaseTableCell } from 'src/app/interfaces/tables/cells/base-table-cell-interface';

@Component({
    standalone: false,
    selector: 'app-field-level-na-button',
    templateUrl: './field-level-na-button.component.html',
    styleUrls: ['./field-level-na-button.component.scss']

})
export class FieldLevelNaButtonComponent implements OnInit {
    @Input()
    fieldSettings: IFieldSettings;

    @Input()
    table: IBaseTable;

    @Input()
    readOnly: boolean = false;

    constructor() {}

    get columns(): IBaseTableCell<any>[] {
        return this.table.table;
    }

    get buttonColor(): string {
        return this.fieldSettings.areAllValuesEmpty ? 'basic' : 'primary';
    }

    get isDisabled(): boolean {
        return this.readOnly || (!this.fieldSettings.areAllValuesNA && !this.fieldSettings.areAllValuesEmpty);
    }

    ngOnInit(): void {}

    setFieldValueForAllCalibrationSets() {
        if (this.fieldSettings.areAllValuesNA) {
            this.columns.forEach((tableCell: IBaseTableCell<any>) => {
                tableCell.value.setCurrentStateValue(this.fieldSettings.name, null);
            });
            this.fieldSettings.setIsNABlocked(false);
        }
        if (this.fieldSettings.areAllValuesEmpty) {
            this.columns.forEach((tableCell: IBaseTableCell<any>) => {
                tableCell.value.setCurrentStateValue(this.fieldSettings.name, NA_VALUE);
            });
            this.fieldSettings.setIsNABlocked(true);
        }
        this.fieldSettings.detectGlobalChanges(this.table);
    }
}
